import requests from "./httpService";

const AttendanceService = {
  uploadAttendance(body) {
    return requests.post(`/attandence/create`, body);
  },
  attendancePunchout(body) {
    return requests.post(`/attandence/daypunchOut`, body);
  },
  attendancePunchoutNew(body) {
    return requests.post(`/attandence/daypunchOut`, body);
  },
  attendancePunchin(body) {
    return requests.post(`/attandence/daypunchIn`, body);
  },

  attendancePunchinEligibility(compid, userId, date, body) {
    return requests.get(`/punchin/eligibility?company_id=${compid}&empid=${userId}&date=${date}`, body);
  },

  attendanceCheckPunchin(body) {
    return requests.post(`/attandence/checkpunchIn`, body);
  },
  attendanceCheckPunchinNew(body) {
    return requests.post(`/attandence/checkpunchIn`, body);
  },
  getAttendanceHr(compid, body) {
    return requests.get(`/attandence/all?company_id=${compid}&year=2025`, body);
  },
  getAttendanceHrNew(compid, body) {
    return requests.get(`/attandence/aggreegate?company_id=${compid}`, body);
  },

  getAttendanceToday(compid) {
    return requests.get(`/overtime/todayattendance?company_id=${compid}`);
  },

  getAttendance(compid, usserId, body) {
    return requests.get(
      `/attandence/all?company_id=${compid}&user_id=${usserId}`,
      body
    );
  },
  getAttendanceNew(compid, usserId, body) {
    return requests.get(
      `/attandence/aggreegateEmployee?company_id=${compid}&user_id=${usserId}`,
      body
    );
  },
  updateAttendance(id, body) {
    return requests.post(`/attandence/update/${id}`, body);
  },
  getAttendancebySearch(compid, usserId, month, year, body) {
    return requests.get(
      `/attandence/all?company_id=${compid}&user_id=${usserId}&month=${month}&year=${year}`,
      body
    );
  },
  getAttendancebySearchNew(compid, usserId, month, year, body) {
    return requests.get(
      `/attandence/aggreegateEmployee?company_id=${compid}&user_id=${usserId}&month=${month}&year=${year}`,
      body
    );
  },
  getAttendancebySearchHrNew(compid, usserId, dept, month, year, body) {
    return requests.get(
      `/attandence/aggreegate?company_id=${compid}&user_id=${usserId}&deptId=${dept}&month=${month}&year=${year}`,
      body
    );
  },
  getAttendancebyReport(compid, month, year, body) {
    return requests.get(
      `attandence/employeesWorkingHours?company_id=${compid}&month=${month}&year=${year}`,
      body
    );
  },

  // 🆕 View Overtime Report (Unified)
  getOvertimeReport(body) {
    return requests.post(`/attandence/view-overtime-report`, body);
  },

  // 🛠️ Manual Overtime Adjustment
  manualAdjustment(body) {
    return requests.post(`/attandence/manual-overtime-adjustment`, body);
  },

};




export default AttendanceService;
